import { defineModel, serializable, castings as castTo } from '../model'

class OperationQualification {
    @serializable()
    id: number

    @serializable()
    @castTo.model('CodeEntry')
    kind: ApiModel<'CodeEntry'>

    @serializable()
    @castTo.collection('CodeEntry')
    qualifications: ApiModel<'CodeEntry'>[]
}

export default defineModel(OperationQualification)
